import { FunctionalComponent } from 'preact';
import { ShowTile } from '##/services/tenApi/common/types';
import PosterCarouselTile from '../StandardCarousel/PosterCarouselTile';
import { AddFavouritesTile } from './AddFavouritesTile';

const FavouritesCarouselTile: FunctionalComponent<ShowTile & {
  isInbound: boolean;
  domId: string;
  isAddMoreShowsButton?: boolean;
  displayAsBanner?: boolean;
}> = ({ ...props }) => {
  if (props.isAddMoreShowsButton) {
    return (
      <AddFavouritesTile displayAsBanner={props.displayAsBanner || false} />
    );
  }
  return <PosterCarouselTile {...props} />;
};

export default FavouritesCarouselTile;
